import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Delete from '@material-ui/icons/Delete';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Grid } from '@material-ui/core';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { contratacionesObservacionesContactoDelete, contratacionesObservacionesContactoStore } from '../../../actions/contrataciones/contratacionesContactos';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { CONTRATACIONES_CONTACTOS_CONTRATOS } from '../../../utils/permisos';

const ObservacionesContactos = ({ disabled }) => {
    const [open, setOpen] = React.useState(false);
    const [observacion, setObservacion] = React.useState("");
    const { observacionesContacto } = useSelector((state) => state.contratacionesContactos);
    const { permisos: permisosUser } = useSelector((state) => state.auth);

    const dispatch = useDispatch()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(contratacionesObservacionesContactoStore({ observacion }, () => setObservacion("")))
    }

    return (
        <>
            <Button color="primary" size={"small"} variant="contained" onClick={handleClickOpen}>OBSERVACIONES</Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{"Observaciones de contactos"}</DialogTitle>
                <DialogContent>
                    {
                        (!disabled && validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTACTOS_CONTRATOS.ALTA)) &&
                        <ValidatorForm onSubmit={handleSubmit}>
                            <Grid container spacing={1} alignItems='center' justify="space-between" style={{ marginBottom: "1.5rem" }}>
                                <Grid item xs={10}>
                                    <TextValidator
                                        label="Observaciones"
                                        fullWidth
                                        autoComplete="off"
                                        value={observacion}
                                        onChange={(e) => setObservacion(e.target.value)}
                                        validators={["required"]}
                                        errorMessages={["Las observaciones son requeridas"]}
                                        multiline
                                    />
                                </Grid>
                                <Grid item>
                                    <Button type="submit" variant="contained" color="primary">Guardar</Button>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    }
                    <TableGeneric
                        data={observacionesContacto}
                        columns={[
                            {
                                label: "Observaciones",
                                id: "observacion",
                                sort: true
                            },
                            {
                                label: "Fecha",
                                id: "fechaAlta",
                                sort: true,
                                customBody: (item) => moment(item.categoria).format("DD/MM/YYYY")
                            },
                            {
                                label: "Usuario",
                                id: "usuarioAlta.userName",
                                sort: true
                            },
                            {
                                label: "",
                                id: "",
                                customBody: (item) => validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTACTOS_CONTRATOS.BAJA) &&<Button color="primary" size={"large"} startIcon={<Delete />} onClick={() => { dispatch(contratacionesObservacionesContactoDelete(item.idEfectorContactoObservacion)) }} />
                            }
                        ]}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ObservacionesContactos
